// The one brand every proposal carries (CG QA, 25 Oct 2026: Collings colours
// for everyone, not agent-editable). Mirrors COLLINGS_BRANDING on the API so
// the builder and template previews match the vendor page.
export const COLLINGS_BRAND = {
  agency_name: "Collings Real Estate",
  logo_url: "https://crm.collings.com.au/collingslogo-removebg-preview.png",
  primary_colour: "#55c5d0",
  footer_text: "Collings Real Estate",
};
